import ShowcaseEventBanner from './showcase-event-banner'

export default ShowcaseEventBanner
